/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { CustomerApplication } from '../models/customer-application';
import { CeresTagFarm } from '../models/ceres-tag-farm';
@Injectable({
  providedIn: 'root',
})
class CeresTagService extends __BaseService {
  static readonly CeresTagStartOnboardingPath = '/api/Application/CeresTag/StartOnboarding';
  static readonly CeresTagGetPath = '/api/Application/CeresTag/Get';
  static readonly CeresTagPurchasePath = '/api/Application/CeresTag/Purchase';
  static readonly CeresTagOnboardPath = '/api/Application/CeresTag/Onboard';
  static readonly CeresTagConfirmPath = '/api/Application/CeresTag/Confirm';
  static readonly CeresTagSetupIndiciumCloudPath = '/api/Application/CeresTag/SetupIndiciumCloud';
  static readonly CeresTagAddFarmPath = '/api/Application/CeresTag/AddFarm';
  static readonly CeresTagUpdateFarmPath = '/api/Application/CeresTag/UpdateFarm';
  static readonly CeresTagDeletePath = '/api/Application/CeresTag/DeleteFarm';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @param params The `CeresTagService.CeresTagStartOnboardingParams` containing the following parameters:
   *
   * - `state`:
   *
   * - `redirect_uri`:
   *
   * - `client_id`:
   */
  CeresTagStartOnboardingResponse(params: CeresTagService.CeresTagStartOnboardingParams): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.state != null) __params = __params.set('state', params.state.toString());
    if (params.redirectUri != null) __params = __params.set('redirect_uri', params.redirectUri.toString());
    if (params.clientId != null) __params = __params.set('client_id', params.clientId.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/Application/CeresTag/StartOnboarding`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param params The `CeresTagService.CeresTagStartOnboardingParams` containing the following parameters:
   *
   * - `state`:
   *
   * - `redirect_uri`:
   *
   * - `client_id`:
   */
  CeresTagStartOnboarding(params: CeresTagService.CeresTagStartOnboardingParams): __Observable<Blob> {
    return this.CeresTagStartOnboardingResponse(params).pipe(
      __map(_r => _r.body as Blob)
    );
  }

  /**
   * @param customerId undefined
   */
  CeresTagGetResponse(customerId?: number): __Observable<__StrictHttpResponse<CustomerApplication>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (customerId != null) __params = __params.set('customerId', customerId.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/Application/CeresTag/Get`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<CustomerApplication>;
      })
    );
  }
  /**
   * @param customerId undefined
   */
  CeresTagGet(customerId?: number): __Observable<CustomerApplication> {
    return this.CeresTagGetResponse(customerId).pipe(
      __map(_r => _r.body as CustomerApplication)
    );
  }

  /**
   * @param customerId undefined
   */
  CeresTagPurchaseResponse(customerId?: number): __Observable<__StrictHttpResponse<CustomerApplication>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (customerId != null) __params = __params.set('customerId', customerId.toString());
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/Application/CeresTag/Purchase`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<CustomerApplication>;
      })
    );
  }
  /**
   * @param customerId undefined
   */
  CeresTagPurchase(customerId?: number): __Observable<CustomerApplication> {
    return this.CeresTagPurchaseResponse(customerId).pipe(
      __map(_r => _r.body as CustomerApplication)
    );
  }

  /**
   * @param params The `CeresTagService.CeresTagOnboardParams` containing the following parameters:
   *
   * - `state`:
   *
   * - `customerId`:
   *
   * - `clientId`:
   */
  CeresTagOnboardResponse(params: CeresTagService.CeresTagOnboardParams): __Observable<__StrictHttpResponse<CustomerApplication>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.state != null) __params = __params.set('state', params.state.toString());
    if (params.customerId != null) __params = __params.set('customerId', params.customerId.toString());
    if (params.clientId != null) __params = __params.set('clientId', params.clientId.toString());
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/Application/CeresTag/Onboard`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<CustomerApplication>;
      })
    );
  }
  /**
   * @param params The `CeresTagService.CeresTagOnboardParams` containing the following parameters:
   *
   * - `state`:
   *
   * - `customerId`:
   *
   * - `clientId`:
   */
  CeresTagOnboard(params: CeresTagService.CeresTagOnboardParams): __Observable<CustomerApplication> {
    return this.CeresTagOnboardResponse(params).pipe(
      __map(_r => _r.body as CustomerApplication)
    );
  }
  CeresTagConfirmResponse(): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/Application/CeresTag/Confirm`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }  CeresTagConfirm(): __Observable<Blob> {
    return this.CeresTagConfirmResponse().pipe(
      __map(_r => _r.body as Blob)
    );
  }

  /**
   * @param params The `CeresTagService.CeresTagSetupIndiciumCloudParams` containing the following parameters:
   *
   * - `farmId`:
   *
   * - `customerId`:
   */
  CeresTagSetupIndiciumCloudResponse(params: CeresTagService.CeresTagSetupIndiciumCloudParams): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.farmId != null) __params = __params.set('farmId', params.farmId.toString());
    if (params.customerId != null) __params = __params.set('customerId', params.customerId.toString());
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/Application/CeresTag/SetupIndiciumCloud`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param params The `CeresTagService.CeresTagSetupIndiciumCloudParams` containing the following parameters:
   *
   * - `farmId`:
   *
   * - `customerId`:
   */
  CeresTagSetupIndiciumCloud(params: CeresTagService.CeresTagSetupIndiciumCloudParams): __Observable<Blob> {
    return this.CeresTagSetupIndiciumCloudResponse(params).pipe(
      __map(_r => _r.body as Blob)
    );
  }

  /**
   * @param params The `CeresTagService.CeresTagAddFarmParams` containing the following parameters:
   *
   * - `farmName`:
   *
   * - `customerId`:
   */
  CeresTagAddFarmResponse(params: CeresTagService.CeresTagAddFarmParams): __Observable<__StrictHttpResponse<CeresTagFarm>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.farmName != null) __params = __params.set('farmName', params.farmName.toString());
    if (params.customerId != null) __params = __params.set('customerId', params.customerId.toString());
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/Application/CeresTag/AddFarm`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<CeresTagFarm>;
      })
    );
  }
  /**
   * @param params The `CeresTagService.CeresTagAddFarmParams` containing the following parameters:
   *
   * - `farmName`:
   *
   * - `customerId`:
   */
  CeresTagAddFarm(params: CeresTagService.CeresTagAddFarmParams): __Observable<CeresTagFarm> {
    return this.CeresTagAddFarmResponse(params).pipe(
      __map(_r => _r.body as CeresTagFarm)
    );
  }

  /**
   * @param params The `CeresTagService.CeresTagUpdateFarmParams` containing the following parameters:
   *
   * - `farm`:
   *
   * - `customerId`:
   */
  CeresTagUpdateFarmResponse(params: CeresTagService.CeresTagUpdateFarmParams): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = params.farm;
    if (params.customerId != null) __params = __params.set('customerId', params.customerId.toString());
    let req = new HttpRequest<any>(
      'PUT',
      this.rootUrl + `/api/Application/CeresTag/UpdateFarm`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param params The `CeresTagService.CeresTagUpdateFarmParams` containing the following parameters:
   *
   * - `farm`:
   *
   * - `customerId`:
   */
  CeresTagUpdateFarm(params: CeresTagService.CeresTagUpdateFarmParams): __Observable<Blob> {
    return this.CeresTagUpdateFarmResponse(params).pipe(
      __map(_r => _r.body as Blob)
    );
  }

  /**
   * @param params The `CeresTagService.CeresTagDeleteParams` containing the following parameters:
   *
   * - `farmId`:
   *
   * - `customerId`:
   */
  CeresTagDeleteResponse(params: CeresTagService.CeresTagDeleteParams): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.farmId != null) __params = __params.set('farmId', params.farmId.toString());
    if (params.customerId != null) __params = __params.set('customerId', params.customerId.toString());
    let req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl + `/api/Application/CeresTag/DeleteFarm`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param params The `CeresTagService.CeresTagDeleteParams` containing the following parameters:
   *
   * - `farmId`:
   *
   * - `customerId`:
   */
  CeresTagDelete(params: CeresTagService.CeresTagDeleteParams): __Observable<Blob> {
    return this.CeresTagDeleteResponse(params).pipe(
      __map(_r => _r.body as Blob)
    );
  }
}

module CeresTagService {

  /**
   * Parameters for CeresTagStartOnboarding
   */
  export interface CeresTagStartOnboardingParams {
    state?: null | string;
    redirectUri?: null | string;
    clientId?: null | string;
  }

  /**
   * Parameters for CeresTagOnboard
   */
  export interface CeresTagOnboardParams {
    state?: null | string;
    customerId?: number;
    clientId?: null | string;
  }

  /**
   * Parameters for CeresTagSetupIndiciumCloud
   */
  export interface CeresTagSetupIndiciumCloudParams {
    farmId?: null | string;
    customerId?: number;
  }

  /**
   * Parameters for CeresTagAddFarm
   */
  export interface CeresTagAddFarmParams {
    farmName?: null | string;
    customerId?: number;
  }

  /**
   * Parameters for CeresTagUpdateFarm
   */
  export interface CeresTagUpdateFarmParams {
    farm: CeresTagFarm;
    customerId?: number;
  }

  /**
   * Parameters for CeresTagDelete
   */
  export interface CeresTagDeleteParams {
    farmId?: null | string;
    customerId?: null | number;
  }
}

export { CeresTagService }
